<template>
  <div class="report-middle-section p-2" :class="{ 'bg-yellow-200 border-yellow-400' : outlier }">
    <h4 class="text-xl text-center py-0 my-0">{{ name }}</h4>
    <div class="flex justify-between">
        <div v-if="dominant == lefttitle" class="font-bold">{{ lefttitle }}</div>
        <div v-else class="font-bold">{{ lefttitle }}</div> 
        <div v-if="dominant == righttitle" class="font-bold">{{ righttitle }}</div> 
        <div v-else class="font-bold"> {{ righttitle }}</div> 
      </div>
    <div class="border-gray-800 border">
      <div class="sterlingbars-diversity sterlingbars-wrapper">
        <div class="trait-wrapper">
          <div class="trait-bar">
            <div class="trait-score" :style="{ left: percentagescore }">
              <!-- {{ score }} -->
            </div>
            <!-- <div v-if="std" class="trait-spread" :style="{ width: spreadwidth, left: spreadleft }"> &nbsp;
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="flex">
        <div v-if="dominant == lefttitle" class="w-1/2 enddesc enddesc-left bg-indigo-200 text-gray-900">
          {{ leftdesc }}
        </div>
        <div v-else class="w-1/2 enddesc enddesc-left">
          {{ leftdesc }}
        </div>
        <div v-if="dominant == righttitle" class="w-1/2 enddesc enddesc-right bg-indigo-200 text-gray-900">
          {{ rightdesc }}
        </div>
        <div v-else class="w-1/2 enddesc enddesc-right">
          {{ rightdesc }}
        </div>
      </div> -->
    </div>
  </div>
</template>
<!-- For Yellow Bars - IF( (userScore<(avg-std) OR userScore>(avg+std) ) -->
<script>
export default {
    
  props: {
    name: '',
    avg: '',
    std: '',
    score: '',
    lefttitle: '',
    leftdesc: '',
    righttitle: '',
    rightdesc: '',
    dominant: '',
  },
  data() {
    return {
      avgFloat: parseFloat(this.avg),
      stdFloat: parseFloat(this.std)
    }
  },
  computed: {
    percentagescore : function() {
      return (this.score) + '%';
    },
    spreadwidth : function() {
      return (this.std) * 2 + '%';
    },
    spreadleft : function() {
      return (this.avg) - (this.std) + '%';
    },
    outlierleft : function() {
      return (this.avg - this.std);
    },
    outlierright : function() {
      return (this.avgFloat + this.stdFloat);
    },
    outlier : function() {
      return (this.score) < (this.avgFloat - this.stdFloat) || (this.score) > (this.avgFloat + this.stdFloat);
    }
  },

};
</script>